import Ajv from "ajv";

const ajv = new Ajv({ allErrors: true });

export default function validate(schema, data) {
  const test = ajv.compile(schema);
  const valid = test(data);
  return !valid && ajv.errorsText(test.errors);
}
